<!--
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-21 09:22
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-11-24 15:12
 * @FilePath: \glyun_web_Vue3\src\App.vue
 * @Description: APP
-->

<template>
  <el-config-provider :size="size" :z-index="zIndex" :locale="locale">
    <RouterView />
  </el-config-provider>
</template>
<script>
import { useSystemConfigStore } from '@/stores/system'
import { useUserStore } from './stores/user';
import _CONST from './const';
import { userFind } from './api/login';
// import { switchVersionMessageBus } from './utils/postMessge';
import { handleIsNewVersionPath } from './utils/postMessge/toggleVersion';
import whitelist from '@/utils/whitelist.js'

export default defineComponent({
  // components: {
    //   ElConfigProvider,
    // },
  setup() {
    const isInit = ref(true)
    const newOldRouteMap = _CONST.newOldRouteMap
    const userStore = useUserStore()

    // 监听 userInfo 中 useNew 属性的变化
    watch(
      () => userStore.userInfo?.useNew,
      (newUseNew, oldUseNew) => {
        console.log('useNew changed:', oldUseNew, '->', newUseNew)
      },
      {
        immediate: true // 立即触发一次
      }
    )

    console.log("行号: 32", JSON.parse(localStorage.getItem('userInfo')))
    console.log("行号: 33", JSON.parse(localStorage.getItem('userInfo'))?.useNew)
    console.log("行号: 34", JSON.parse(JSON.stringify(userStore.userInfo.useNew)))


    const router = useRouter()
    const routes = useRoute()

    const systemConfigStore = useSystemConfigStore()
    systemConfigStore.updateLang(getSystemLanguage("number"))
    const locale = computed(() => {
      console.log("🚀 ~ locale ~ getElementPlusLangJson(systemConfigStore.language):",systemConfigStore.language, getElementPlusLangJson(systemConfigStore.language))
      return getElementPlusLangJson(systemConfigStore.language)
    })
    // 当前新路由，但是是老版本，手动切换成老版本
    const handleRefreshOldVersion = (newVal) => {
        console.log('handleRefreshOldVersion',isInit.value,newVal)
      let path = newVal
      // 用 userInfo.id 判断登录状态（Token 改为 HttpOnly Cookie 后无法通过 JS 读取）
      const userInfoStr = localStorage.getItem('userInfo')
      const isLoggedIn = userInfoStr && JSON.parse(userInfoStr).id
      const url = new URL(window.location.href);
      const params = url?.searchParams?.get('token');
      const verifyToken = Boolean(window.location.href?.indexOf('/modify_password') != -1 && params)
      if (isLoggedIn && path && !whitelist.includes(path) && isInit.value && !verifyToken) {
        console.log('判断了')
        userFind().then(res => {
          const useNew = res?.data?.useNew
          if (!useNew && handleIsNewVersionPath(path)) {
            isInit.value = false
            switchUiVersions(useNew)
            setTimeout(() => {
             isInit.value = true
            },1000)
          }
          // userStore.updateUserInfo(res.data) // 保存用户信息到Store
        })
      }

    }

    // 监听路由变化，清空dom元素poper-container内容
    watch(
      () => router.currentRoute.value,
      (newValue) => {
        const elem = document.getElementById("poper-container");
        elem && (elem.innerHTML = "")
        userStore.updateStoreRoutes(routes)
        handleRefreshOldVersion(newValue?.path)
      },
      {
        immediate: true
      }
    );
    // 挂载监听版本切换监听方法
    // switchVersionMessageBus(handleRefreshOldVersion).getMessage()
    // watch(() => routes.path, (newVal) => {
    //     console.log('routes33', newVal)
    //     handleRefreshOldVersion(newVal)
    //   }, {
    //     deep:true
    //   })

    return {
      zIndex: 2000,
      size: 'default',
      locale: locale,
    }
  },
})
</script>
